// extracted by mini-css-extract-plugin
export default {"row":"PlayerStatsRow_row__Y5r05","cell":"PlayerStatsRow_cell__RrrwN","cell_first":"PlayerStatsRow_cell_first__rM-eM","cell_player_name":"PlayerStatsRow_cell_player_name__KpLQ2"};